<h2 mat-dialog-title>{{ 'Rinomina azione' | siaTranslate }}</h2>

<mat-icon
  mat-button
  mat-dialog-close
  (click)="closeDialog()"
  class="sia-dialog-close-button"
>
  Close
</mat-icon>

<div matDialogContent>
  <div class="flex flex-row flex-wrap gap-2">
    <sia-text-box [(value)]="actionName"></sia-text-box>
  </div>
</div>

<mat-dialog-actions align="end">
  <button mat-button (click)="saveAction()" [autofocus]="true">
    {{ 'Salva' | siaTranslate }}
  </button>
  <button mat-button (click)="closeDialog()" class="button-grey">
    {{ 'Annulla' | siaTranslate }}
  </button>
</mat-dialog-actions>
